import { render, staticRenderFns } from "./CfoMarginEvents.vue?vue&type=template&id=7053608a&scoped=true"
import script from "./CfoMarginEvents.vue?vue&type=script&lang=js"
export * from "./CfoMarginEvents.vue?vue&type=script&lang=js"
import style0 from "./CfoMarginEvents.vue?vue&type=style&index=0&id=7053608a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7053608a",
  null
  
)

export default component.exports